import React from "react";
import type { GraphNode } from "../../../utils";

export interface AttributeSelectedContextValue {
  onSelectAttribute?: (node: GraphNode) => void;
}

export const AttributeSelectedContext = React.createContext<AttributeSelectedContextValue | null>(null);

export interface AttributeSelectedProviderProps {
  children: React.ReactNode;
  onSelectAttribute?: (node: GraphNode) => void;
}

const AttributeSelectedProvider = (props: AttributeSelectedProviderProps) => {
  const { children, onSelectAttribute } = props;
  const value = React.useMemo(() => ({ onSelectAttribute }), [onSelectAttribute]);
  return <AttributeSelectedContext.Provider value={value}>{children}</AttributeSelectedContext.Provider>;
};

export const useAttributeSelected = () => React.useContext(AttributeSelectedContext);

export default AttributeSelectedProvider;
